module.exports = __webpack_public_path__ + "img/no_profile_back.e2f9f7e6.jpg";